import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RequireRole } from './components/auth/RequireRole';

// Pages
import { HomePage }          from './pages/HomePage';
import { AuthCallback }      from './pages/AuthCallback';
import { AdminDashboard }      from './pages/admin/AdminDashboard';
import { AdminMaidsPage }      from './pages/admin/AdminMaidsPage';
import { AdminLoginPage }      from './pages/admin/AdminLoginPage';
import { AdminEstimatorPage }  from './pages/admin/AdminEstimatorPage';
import { DevLoginPage }        from './pages/DevLoginPage';
import { EstimatorPage }       from './pages/EstimatorPage';
import { EstimatorHistoryPage }  from './pages/EstimatorHistoryPage';
import { MaidApplicationPage }   from './pages/MaidApplicationPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/"               element={<HomePage />} />
          <Route path="/estimate"       element={<EstimatorPage />} />
          <Route path="/estimate/live"  element={<Navigate to="/estimate" replace />} />
          <Route path="/become-a-maid"  element={<MaidApplicationPage />} />
          <Route path="/auth/callback"  element={<AuthCallback />} />
          <Route path="/admin/login"    element={<AdminLoginPage />} />
          {import.meta.env.DEV && <Route path="/dev-login" element={<DevLoginPage />} />}

          {/* Any authenticated user */}
          <Route path="/estimate/history"  element={<RequireRole><EstimatorHistoryPage /></RequireRole>} />

          {/* Admin-only */}
          <Route path="/admin"               element={<RequireRole roles={['ADMIN']}><AdminDashboard /></RequireRole>} />
          <Route path="/admin/maids"         element={<RequireRole roles={['ADMIN']}><AdminMaidsPage /></RequireRole>} />
          <Route path="/admin/estimator"     element={<RequireRole roles={['ADMIN']}><AdminEstimatorPage /></RequireRole>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
